// extracted by css-extract-rspack-plugin
export default {"checklistButton":"checklistButton-XcRR3C","checklistIcon":"checklistIcon-kIMVRe","badge":"badge-C3vB3z"};